import React from 'react';
import { useContentProtection } from '../../hooks/useContentProtection';

/** Wraps student portal pages with copy/screenshot deterrence. */
export default function ContentProtection({ children, enabled = true }) {
  useContentProtection(enabled);
  return <div className="sba-protected-root">{children}</div>;
}
